import html2canvas from "html2canvas-pro";
import jsPDF from "jspdf";

/**
 * The function `printDocument` asynchronously generates a PDF document from two HTML elements
 * represented by `firstPageRef` and `secondPageRef`.
 * @returns The function `printDocument` is returning a PDF document in the form of a Blob object.
 */

const printDocument = async (firstPageRef, secondPageRef) => {

    const pdf = new jsPDF('p', 'mm', 'letter', true);

    const canvasOptions = {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false,
        scrollX: 0,
        scrollY: 0
    };

    const firstPageCanvas = await html2canvas(firstPageRef.current, canvasOptions);
    const secondPageCanvas = await html2canvas(secondPageRef.current, canvasOptions);

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const firstPageimgData = firstPageCanvas.toDataURL('image/png');
    const secondPageimgData = secondPageCanvas.toDataURL('image/png');

    pdf.addImage(firstPageimgData, 'PNG', 0, 0, pageWidth, pageHeight);

    pdf.addPage();

    pdf.addImage(secondPageimgData, 'PNG', 0, 0, pageWidth, pageHeight);

    const pdfBlob = pdf.output('blob');
    return pdfBlob;
};

export default printDocument;